export default "__VITE_ASSET__88d2f879__"